import { supabase } from "../admin/supabase";

/**
 * Service layer for the `hero_slides` table.
 * No component should query Supabase directly for this data —
 * everything goes through these functions so the query shape lives
 * in one place and can be reused by both the public site and the
 * admin CRUD pages.
 */

/** Fetch all published hero slides, ordered for display. */
export async function getHeroSlides() {
  const { data, error } = await supabase
    .from("hero_slides")
    .select("*")
    .eq("published", true)
    .order("display_order", { ascending: true });

  if (error) throw error;
  return data || [];
}
